export const sharedColors = {
  black: '#000000',
  blue1: '#E3F2FD',
  blue2: '#BBDEFB',
  blue4: '#2196F3',
  blue5: '#1976D2',
  blue6: '#0D47A1',
  blue7: '#001D6C',
  gray1: '#FAFAFA',
  gray2: '#F5F5F5',
  gray3: '#efefef',
  gray4: '#ADADAD',
  gray5: '#7A7A7A',
  gray6: '#666666',
  gray7: '#232323',
  gray8: '#EEEEEE',
  purple1: '#F3E5F5',
  purple4: '#BA68C8',
  statusGreen: '#008A00',
  statusGreenLightest: '#EBF6EB',
  statusRed: '#AE0000',
  statusRedLighter: '#DA0101',
  statusRedLightest: '#F7EDED',
  statusYellow: '#EAB600',
  statusYellowDark: '#382C00',
  statusYellowLightest: '#FFFEF1',
  statusOrange: '#ECB010',
  statusOrangeDarkest: '#C18F0A',
  white: '#FFFFFF',
  infoYellow: '#EAB600',
  yellowLightest: '#FFFEF1',
  yellowDark: '#382C00',
  primary: '#3F51B5',
  primaryDark: '#002884',
};

export const sharedStyles = {
  iconColor: {
    color: sharedColors.gray4,
  },
  buttonText: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    textTransform: 'none',
    width: 'fit-content',
  },
  caption: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '11px',
    lineHeight: '13px',
  },
  h2: {
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '20px',
    lineHeight: '33px',
  },
  h3: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '28px',
  },
  h5: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '21px',
  },
  h6: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '19px',
  },
  body1: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
  },
  body2: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
  overline: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '10px',
    lineHeight: '12px',
  },
  outerTableContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  pageBody: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  backIcon: {
    p: 0,
    minHeight: 0,
    height: 'fit-content',
  },
  pageTitle: {
    mb: 3,
  },
  subtitle1: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '19px',
  },
  subtitle2: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '15px',
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: sharedColors.gray1,
    width: '100%',
  },
  tableStringField: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    flexDirection: 'row',
    display: 'flex',
    color: sharedColors.gray7,
  },
  tableSecondaryField: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    flexDirection: 'row',
    display: 'flex',
    color: sharedColors.gray5,
  },
  columnLabel: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
  },
  editableRow: {
    cursor: 'pointer',
  },
  hidden: {
    display: 'none',
  },
  resultChartContainer: {
    flexGrow: 1,
    mt: 2.5,
    p: 2.5,
  },
  tabLabel: {
    textTransform: 'none',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
    color: sharedColors.gray6,
    display: 'flex',
    alignItems: 'center',
    mb: -0.25,
  },
};

export const bodyWidth = {
  xs: '100%',
  sm: 540,
  md: 720,
  lg: 960,
  xl: '80%',
};
